import React from 'react';
import { Navigate } from 'react-router-dom';
import 'swiper/css';
import RejectBottomSheet from '../../ui/RejectBottomSheet';
import SignBottomSheet from '../../ui/SignBottomSheet';
import Complete from '../../ui/Complete';
import PerButton from '../../ui/PerButton';
import UserInfo from '../../ui/UserInfo';
import Tabs from '../../ui/Tabs';
import BaseInfo from '../ui/BaseInfo';
import CheckList from '../ui/CheckList';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import Commons from '../../../../Services/Common/Common';
import DeletePermitBottomSheet from '../../ui/DeletePermitBottomSheet';
import RejectCheckBottomSheet from '../ui/RejectCheckBottomSheet';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';

export default function M_PER_CUSTOM_02(props) {
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const activeStep = useSelector((state) => state.common.activeStep);
  const { baseInfo } = useSelector((state) => state.permit);
  const { userInfo } = useSelector((state) => state.BaseInfo);

  if (!baseInfo) return <div>존재하지 않는 작업허가서입니다.</div>;
  if (props.isComplete)
    return (
      <Box sx={{ px: 2, height: '100%' }}>
        <Complete mode={props.mode} />
      </Box>
    );

  return (
    <Box
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {/* 작성자 정보 */}
      <Box sx={{ flexShrink: 0, py: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <UserInfo
            name={baseInfo.name}
            userImg={baseInfo.photo}
            department={baseInfo.depNmLast}
            position={baseInfo.position}
          />
          {baseInfo?.returnStatus === 'Y' && (
            <button
              style={{
                border: '1px solid #FF6161',
                backgroundColor: '#FFF5F5',
                borderRadius: '8px',
                padding: '8px 16px',
                fontSize: '14px',
                color: '#FF6161',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 1px 3px rgba(255, 97, 97, 0.1)',
              }}
              onClick={() => {
                dispatch(
                  BottomSheetActions.SetBottomSheetState({
                    bottom: true,
                    type: 'rejecCheck',
                  })
                );
              }}
            >
              <span>반려 내용</span>
            </button>
          )}
        </Box>
      </Box>

      {/* 탭 */}
      <Box sx={{ flexShrink: 0 }}>
        <Tabs
          activeIndex={props.activeIndex}
          setActiveIndex={props.setActiveIndex}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        }}
      >
        {props.activeIndex === 0 && (
          <BaseInfo
            rowData1={baseInfo}
            isChecked={props.isBaseChecked}
            setIsChecked={props.setIsBaseChecked}
          />
        )}
        {props.activeIndex === 1 && (
          <CheckList
            isChecked={props.isChecklistChecked}
            setIsChecked={props.setIsChecklistChecked}
            completedSections={props.completedSections}
            setCompletedSections={props.setCompletedSections}
          />
        )}
      </Box>
      <Box sx={{ flexShrink: 0, py: 2 }}>
        {baseInfo.gubun === '요청' &&
        baseInfo.userId &&
        userInfo?.userid &&
        baseInfo.userId !== Commons.DecryptoAES(userInfo.userid) ? (
          <PerButton
            onCancel={() =>
              dispatch(
                BottomSheetActions.SetBottomSheetState({
                  bottom: true,
                  type: 'reject',
                })
              )
            }
            onClick={() => {
              if (!props.isBaseChecked) {
                props.setActiveIndex(0);
                dispatch(
                  showSnackbar({
                    message: '기본 작성 정보를 확인하세요.',
                    type: 'warning',
                  })
                );
                return;
              }
              if (!props.isChecklistChecked) {
                props.setActiveIndex(1);
                dispatch(
                  showSnackbar({
                    message: '각 항목을 확인하세요.',
                    type: 'warning',
                  })
                );
                return;
              }
              dispatch(
                BottomSheetActions.SetBottomSheetState({
                  bottom: true,
                  type: 'sign',
                })
              );
            }}
            cancelText="반려"
            cancelColor={'#FF6161'}
            saveText="승인"
          />
        ) : null}
        {baseInfo.userId &&
          Commons.DecryptoAES(userInfo.userid) &&
          baseInfo.userId === Commons.DecryptoAES(userInfo.userid) && (
            <PerButton
              cancelText={'삭제'}
              saveText={'수정'}
              cancelColor={'#FF6161'}
              onCancel={() => {
                dispatch(
                  BottomSheetActions.SetBottomSheetState({
                    bottom: true,
                    type: 'delete',
                  })
                );
              }}
              onClick={() => {
                dispatch(CommonActions.setActiveStep(activeStep + 1));
                navigate(`/M_Permit/write/${baseInfo.pmCd}`);
              }}
            />
          )}
      </Box>
      {!baseInfo && <Navigate to="/M_Permit" replace />}
      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'reject' && (
        <RejectBottomSheet Save1={props.Save1} />
      )}
      {bottomSheetState.bottom && bottomSheetState.type === 'sign' && (
        <SignBottomSheet
          signatureCanvas={props.signatureCanvas}
          Save1={props.Save1}
          onComplete={() => props.setIsComplete(true)}
          setMode={props.setMode}
        />
      )}
      {bottomSheetState.bottom && bottomSheetState.type === 'delete' && (
        <DeletePermitBottomSheet
          Delete1={props.Delete1}
          title={'작업허가서를 삭제하시겠습니까?'}
        />
      )}

      {bottomSheetState.bottom && bottomSheetState.type === 'rejecCheck' && (
        <RejectCheckBottomSheet />
      )}
    </Box>
  );
}
